// extracted by mini-css-extract-plugin
module.exports = {"deepdive-container":"EvaluateProducts__deepdive-container___1k6ry","deepdive-image-container":"EvaluateProducts__deepdive-image-container___1oS8B"};